export interface ApiResponse<T = any> {
  statusCode: number;
  message: string;
  status?: string;
  data?: T;
}

export enum ErrorSource {
  AUTHENTICATION = 'authentication',
  PROFILE = 'profile',
  SEND_CODE_VERIFICATION = 'send_code_verification',
  VERIFY_CODE = 'verify_code',
  VERIFY_PHONE = 'verify_phone',
  SEND_EMAIL_VERIFICATION = 'send_email_verification',
  COMPLETE_SIGNUP = 'complete_signup',
  PAYMENT = 'payment',
  GENERAL = 'general',
  PARTNER_LIST = 'partner_list',
  PARTNER_DETAILS = 'partner_details',
  USER_PROFILE = 'user_profile',
  MEMBER_SIGNUP = 'member_signup',
  UPDATE_ENROLLMENT = 'update_enrollment',
  DEMOGRAPHICS = 'demographics',
  COUNTRY_STATES = 'country_states',
  STATE_CITIES = 'state_cities',
  COACH_DEMOGRAPHICS = 'coach_demographics',
  COMPLETE_ENROLLMENT = 'complete_enrollment',
  SCHEDULE_CHANGE_REQUEST = 'schedule_change_request',
  PAUSE_SERVICE = 'pause_service',
  END_SERVICE = 'end_service',
  UPDATE_PERSONAL_INFO = 'update_personal_info',
  SUBSCRIPTIONS_LIST = 'subscription_list',
  SUBSCRIPTION_DETAILS = 'subscription_details',
  CREATE_STRIPE_CUSTOMER = 'create_stripe_customer',
  CREATE_PAYMENT_INTENT = 'create_payment_intent',
  UPDATE_PAYMENT_INTENT = 'update_payment_intent',
  VALIDATE_PROMO_CODE = 'validate_promo_code',
}

export interface ApiError {
  source: ErrorSource;
  message: string;
  statusCode: number;
  // originalError?: any;
  stack?: string;
  timestamp: number;
}
